<template>
    <div>
        <div class=" noPayClass clearfix">
            <img :src="obj.image" v-if='obj.image' alt=""  class="col-md-2 mr-3">
            <div class="col-md-9" :class="obj.image?'col-md-9':'col-md-12'">
                <h5>{{obj.title}}</h5>
                <p class="three_ell">{{obj.description}}</p>
                <div class="noPayFoot">
                    <span>Share：</span><img src="../../../assets/images/silkRoadBase/weixincur.png" alt="" @mouseenter="codeToggle(true)" @mouseleave="codeToggle(false)">
                    <div id="qrcode" class="codeDiv" v-show='codeShow'></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2'
    export default {
        name: "noPay",
        data(){
            return{
                codeShow:false
            }
        },
        props:{
            obj: {
                type: Object,
                default: {}
            },
        },
        methods:{
            qrcode () {
                document.getElementById("qrcode").innerHTML = "";
                let qrcode = new QRCode('qrcode', {
                    width: 100,
                    height: 100, // 高度  [图片上传失败...
                    text: window.location.href
                })
            },
            codeToggle(type){
                this.qrcode();
                this.codeShow=type;
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
.noPayClass{
    padding: 20px 24px;
    background:rgba(245,246,247,1);
    margin-bottom:30px;
    margin-top:10px;
}
.noPayClass>img,.noPayClass>div{
    float: left;
    padding: 0;
}
    .noPayClass h5{
        height:26px;
        overflow: hidden;
        font-size:18px;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(38,38,38,1);
        line-height:26px;
    }
    .noPayClass{
        text-align:left;
    }
    .noPayClass p{
        font-size:13px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        height: 66px;
        line-height:22px;
    }
    .noPayClass span{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:600;
        color:rgba(0,0,0,1);
        line-height:20px;
    }
    .noPayFoot{
        position:relative;
    }
    .codeDiv{
        position:absolute;
        width: 100px;
        height:100px;
    }
    .noPayFoot img{
        width:24px;
        padding: 0;
        height:24px;
    }
    .noPayClass img:hover{
        cursor: pointer;
    }
    .three_ell{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
</style>
